// Generated by openapi-codegen. Do not edit manually.

import * as z from 'zod';

export const generateTimesheetProposalPathParamsSchema = z.object({
  account_id: z.number().int().describe("Account ID"),
});

export const generateTimesheetProposalHeaderParamsSchema = z.object({
  Authorization: z.coerce.string().describe("OAuth 2.0 Bearer token"),
});

/**
 * @description Generation started
 */
export const generateTimesheetProposal202Schema = z.object({
  message: z.coerce.string(),
  job_id: z.optional(z.coerce.string()),
  estimated_completion_time: z.optional(z.coerce.string()),
});

export const generateTimesheetProposalMutationRequestSchema = z.object({
  date: z.string().date(),
  timely_user_id: z.optional(z.number().int()),
  timely_account_id: z.optional(z.number().int()),
  generation_mode: z.optional(z.enum(["manual", "auto"])),
  force_regenerate: z.optional(z.boolean()),
  session_id: z.number().int().nullish(),
  metadata: z.optional(z.object({
    effort: z.optional(z.coerce.string()),
    interval_minutes: z.optional(z.coerce.string()),
    provider: z.optional(z.coerce.string()),
    note_language: z.optional(z.coerce.string()),
  })),
});

export const generateTimesheetProposalMutationResponseSchema = z.lazy(() => generateTimesheetProposal202Schema);
